module.exports = __webpack_public_path__ + "img/zcBg.4c23cf5.png";